<template>
  <div
    class="k-button-wrapper"
    :class="{
      'k-button-wrapper--spaced': spaced,
    }"
  >
    <div class="k-button" :class="computedClassNames">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { getDeviceType } from "@/utils/device";

export default defineComponent({
  name: "CommonButton",
  props: {
    icon: {
      type: String,
      default: "",
    },
    isAndroid: {
      type: Boolean,
      default: getDeviceType() === "android",
    },
    flat: {
      type: Boolean,
      default: false,
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    spaced: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "primary",
    },
  },
  computed: {
    computedClassNames() {
      const typeClassName = `k-button--${this.type}`;
      return {
        "k-button--outlined": this.outlined,
        "k-button--flat": this.flat,
        [typeClassName]: this.type,
        "k-button--android": this.isAndroid,
        "k-button--ios": !this.isAndroid,
      };
    },
  },
});
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";
.k-button-wrapper {
  &--spaced {
    padding: 15px;
  }

  .k-button {
    font-family: Roboto-Regular;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    border-radius: 2px;
    color: $colorWhite;
    cursor: pointer;
    user-select: none;

    &--ios {
      font-size: 17px;
      height: 56px;
    }

    &--android {
      font-size: 14px;
      text-transform: uppercase;
      height: 44px;
    }

    &--outlined {
      background-color: transparent !important;
      box-shadow: 0px 0px 0px 1px $colorButtonMain inset;
      color: $colorButtonMain !important;
    }

    &--flat {
      color: $colorButtonMain !important;
      background-color: transparent !important;
    }

    &--primary {
      color: $colorWhite;
      background-color: $colorButtonMain;
    }

    &--secondary {
      color: $colorButtonMain;
      background-color: $colorSmoke;
    }

    &--accent {
      color: $colorWhite;
      background-color: $colorKiwiGreenLighter;
    }
  }
}
</style>
